import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToOtherFormats = {
  [titleId: string]: WpsTypes.atv.wps.OtherFormatsModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.otherFormats,
  {} as TitleIdToOtherFormats
)